'use client'

import type { MergedArticle } from '@/feature/product/types/mergedProduct'
import { memo, useMemo, useState } from 'react'
import { useReferencesProductTableContext } from './ReferencesProductContext'
import { ReferencesProductRowDesktop } from './ReferencesProductRowDesktop.client'
import { ReferencesProductRowDesktopDetailsWrapper } from './ReferencesProductRowDesktopDetailsWrapper.client'
import { ReferencesProductRowMobile } from './ReferencesProductRowMobile.client'

export const TECHNICAL_SPECS_LIMIT = 3

export type ReferencesProductRowProps = {
  article: MergedArticle
  position?: number
}

function ReferencesProductRowComponent({ article, position }: ReferencesProductRowProps) {
  const { isDesktopWidth, favoriteMap, pickupPointOfSale } = useReferencesProductTableContext()

  const [selectedQuantity, setSelectedQuantity] = useState(1)

  const isFavorite = useMemo(
    () => favoriteMap?.[article.reference],
    [favoriteMap, article.reference],
  )

  return (
    <>
      {isDesktopWidth ? (
        <>
          <ReferencesProductRowDesktop
            article={article}
            setSelectedQuantity={setSelectedQuantity}
            selectedQuantity={selectedQuantity}
          />
          <ReferencesProductRowDesktopDetailsWrapper
            article={article}
            isFavorite={isFavorite}
            position={position}
            selectedQuantity={selectedQuantity}
            pickupPointOfSale={pickupPointOfSale}
          />
        </>
      ) : (
        <ReferencesProductRowMobile
          article={article}
          isFavorite={isFavorite}
          setSelectedQuantityAction={setSelectedQuantity}
          selectedQuantity={selectedQuantity}
          pickupPointOfSale={pickupPointOfSale}
        />
      )}
    </>
  )
}

export const ReferencesProductRow = memo(ReferencesProductRowComponent)
